import type { IconData } from '@stacksjs/iconify-core'

export const chevronDoubleUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m259.516 173.771l109.021 109.021L448 203.329L338.979 94.308l.041-.041l-68.148-68.149l-4.328-4.3l-7-7.085l-.067.067l-68.151 68.153l-11.338 11.421L71.033 203.329l79.467 79.463ZM214 105.622L225.334 94.2l34.115-34.115l.041.041l.067-.067l34.208 34.208l-.041.041l109.021 109.021l-34.208 34.208l-109.021-109.021L150.5 237.537l-34.207-34.208Z\"/><path fill=\"currentColor\" d=\"m338.953 315.408l-68.081-68.081l-11.289-11.206l-.108-.108l-68.149 68.148l-11.272 11.356L71.033 424.538L150.5 504l109.016-109.021L368.537 504L448 424.538L338.912 315.45Zm63.792 109.13l-34.208 34.207l-109.021-109.021L150.5 458.745l-34.207-34.207L214 326.831l11.256-11.34l34.265-34.265l34.316 34.316l-.041.041Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default chevronDoubleUp
